import type { AgentUsageInput } from '@travel-planner/shared/schemas/agent-usage';
import type { DateRangeValue } from '@/shared/ui';
import type { AiUsageSearch } from '../model/search-params';
import { AGENT_USAGE_DOORS } from '@travel-planner/shared/schemas/agent-usage';
import { Checkbox, DateRangePicker, MultiSelect } from '@/shared/ui';
import { DOOR_LABEL } from '../../../entities/ai-usage';
import { normaliseDoors } from '../model/search-params';
import css from './ai-usage-filters.module.scss';

const DOOR_OPTIONS = AGENT_USAGE_DOORS.map((door) => ({
  label: DOOR_LABEL[door],
  value: door,
}));

type AiUsageFiltersProps = {
  input: AgentUsageInput;
  onChange: (updates: Partial<AiUsageSearch>) => void;
};

export const AiUsageFilters = ({ input, onChange }: AiUsageFiltersProps) => {
  const onPeriodChange = ({ startDate, endDate }: DateRangeValue) => {
    // Cleared → back to the default period.
    if (!(startDate || endDate)) {
      onChange({ from: undefined, to: undefined });
      return;
    }
    if (startDate && endDate) {
      onChange({ from: startDate.slice(0, 10), to: endDate.slice(0, 10) });
    }
  };

  return (
    <div className={css.root}>
      <DateRangePicker
        presets={['custom']}
        value={{
          startDate: `${input.from}T00:00:00.000Z`,
          endDate: `${input.to}T23:59:59.999Z`,
        }}
        onChange={onPeriodChange}
      />
      <div className={css.rootDoors}>
        <MultiSelect
          options={DOOR_OPTIONS}
          // No selection reads as every door.
          values={input.doors ?? []}
          onChange={(values) => onChange({ doors: normaliseDoors(values) })}
          placeholder="Used from: all"
          searchable={false}
          showSelectAll={false}
        />
      </div>
      <Checkbox
        label="Include test sessions"
        checked={input.includeTests === true}
        onChange={(e) => onChange({ tests: e.target.checked ? 1 : undefined })}
      />
    </div>
  );
};
